import { IconAlertTriangle } from '@iwoca/icons';

import { useGetSecurityCheckRequirements } from './useGetSecurityCheckRequirements';

export const SecurityChecksPrompt = () => {
  const { isAnyRequirementVisible, loadingFundingRequirement } =
    useGetSecurityCheckRequirements();

  if (loadingFundingRequirement) return null;
  if (!isAnyRequirementVisible) return null;

  return (
    <div className="my-l flex flex-row rounded-xs border border-core-90 bg-core-95 p-s xs-480:flex-col">
      <div className="mr-s shrink-0 xs-480:mb-xs xs-480:mr-0">
        <IconAlertTriangle className="h-[24px] w-[24px] shrink-0 fill-[#C70E04]" />
      </div>
      <div>
        <div className="pb-xs text-s font-bold">
          You still need to finish your security checks before you can use your
          spending limit
        </div>
        <div className="text-s font-reg">
          Once they're done you'll be able to use your spending limit to finish
          your purchase.
        </div>
      </div>
    </div>
  );
};
